import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './Section';
export function Guarantee() {
  return <Section className="bg-ink-900/60" data-id="element-134" data-mp="1o2vgimx0qj5i">
      <div className="rounded-3xl border border-white/8 bg-ink-950 p-7 sm:p-10" data-id="element-135" data-mp="1o5zrq48wif5o">
        <span className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-400/10" data-id="element-136" data-mp="222mzz36b0rqw">
          <ShieldCheckIcon className="h-7 w-7 text-emerald-300" aria-hidden="true" data-id="element-137" data-mp="1x28rxl4pdhsv" />
        </span>

        <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-138" data-mp="19co9r4gdiokn">
          Tu inversión está completamente protegida
        </h2>

        <div className="mt-6 space-y-4 text-base leading-relaxed text-white/65" data-id="element-139" data-mp="1j5c4ltnsmigq">
          <p data-id="element-140" data-mp="1edk8z4ps5mjq">Queremos que entres sin ningún riesgo.</p>
          <p data-id="element-141" data-mp="1ec0thgby7fj0">
            Por eso, si accedes al contenido y sientes que no aprendiste nada
            útil, que no era lo que esperabas o simplemente que no era para ti,
            puedes solicitar tu devolución dentro del período de garantía
            disponible en la plataforma.
          </p>
          <p className="text-white/85" data-id="element-142" data-mp="oxp0pyicqyys">
            Sin preguntas complicadas. Sin procesos molestos.
          </p>
          <p data-id="element-143" data-mp="ypl0rf400z5n">
            Confiamos en el valor de este contenido porque sabemos lo que puede
            hacer por ti. Pero si por alguna razón no es lo que necesitabas, te
            devolvemos tu dinero.
          </p>
          <p className="font-semibold text-white" data-id="element-144" data-mp="61ffmr91985a">
            Así de simple. Así de justo.
          </p>
        </div>
      </div>
    </Section>;
}